import type { ReactNode } from 'react'

import { ConfirmDialog } from '@/components/molecules/confirm-dialog.molecule'

interface LeaveOrganizationDialogProps {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  onConfirm: () => Promise<void>
}

export const LeaveOrganizationDialog: React.FC<LeaveOrganizationDialogProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
}): ReactNode => (
  <ConfirmDialog
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    title="Leave Organization"
    description="Are you sure you want to leave this organization? You will lose access to all resources."
    confirmLabel="Leave"
    onConfirm={onConfirm}
    variant="destructive"
  />
)

LeaveOrganizationDialog.displayName = 'LeaveOrganizationDialog'
